import ApiUtils from '../helpers/ApiUtils'
import IntegrationsApi from '../apis/IntegrationsApi'
import ProjectBranchesApi from '../apis/ProjectBranchesApi'
import RepositoriesApi from '../apis/RepositoriesApi'

const activate = (platform, token, url) => (
  new IntegrationsApi().create({
    platform,
    token,
    url
  }).then(ApiUtils.handleResponse)
)

const checkPaths = (platform, repositoryId, paths, branch = null) => (
  new IntegrationsApi().checkPaths(
    platform,
    repositoryId,
    paths,
    branch
  ).then(ApiUtils.handleResponse)
)

const fetchAll = () => (
  new IntegrationsApi().all().then(ApiUtils.handleResponse)
)

const fetchBranches = (projectId, platform) => (
  new ProjectBranchesApi(projectId).get({
    query: { platform }
  }).then(ApiUtils.handleResponse)
)

const fetchRepositories = (platform) => (
  new RepositoriesApi().get({
    query: { platform }
  }).then(ApiUtils.handleResponse)
)

const update = (id, token, url) => (
  new IntegrationsApi().update(id, {
    token,
    url
  }).then(ApiUtils.handleResponse)
)

const destroy = (id, deleteProjects = false) => (
  new IntegrationsApi().destroy(id, deleteProjects).then(ApiUtils.handleResponse)
)

export default {
  activate,
  checkPaths,
  destroy,
  fetchAll,
  fetchBranches,
  fetchRepositories,
  update
}
